<template lang="pug">
  .table-view
    .table-view-header
      .table-view-header-title
        h3.text-capitalize {{ [date, "DD-MM-YYYY"] | moment('MMMM YYYY') }}
        b-input-group.table-view-header-filter.mr-2
          template(v-slot:prepend)
            .filter-prepend
              font-awesome-icon(:icon="['fas', 'search']")
          b-form-input(v-model="filter" placeholder="buscar")
        b-select.table-view-header-filter(v-model="filterBusinessId")
          b-select-option(:value="null") -- Seleccione un grupo --
          b-select-option(v-for="group in businessGroups" :value="group.businessesIds") {{ group.name }}
      .table-view-header-actions
        base-date-select(v-model="date" :max-date="getCurrentPeriod()")
    b-table(
      :fields="tableFields"
      :items="filteredItems"
      head-row-variant="light-primary"
      :filter="filter"
      :filter-included-fields="filterOn"
      responsive
      sticky-header="600px"
    )
      template(v-slot:head()="{field}")
        div {{field.label}}
        .subtitulo {{field.collaborator}}
      template(v-slot:head(name)="scope")
        div(class="text-nowrap" ) {{scope.label}}
      template(v-slot:cell(name)="{item}" )
        router-link(:to="{name: 'BusinessDetail', params: { id: item.id } }") {{item.name}}
      template(v-slot:cell(rut)="{value}" )
        div {{value}}
      template(v-slot:cell()="{value,item,field}")
        BaseTaskStateSelect(
          v-if="value === ''"
          placeholder="N/A"
          placeholderColor="#2ECC71"
        )
        BaseTaskStateSelect(
          v-else-if="user.id===field.collaboratorId || user.role==='owner'"
          @change="updateTaskState(item.id ,field.id,$event.name)"
          :states="states"
          v-model="value"
          style="cursor:pointer"
        )
        BaseTaskStateSelect(
          v-else
          @change="updateTaskState(item.id ,field.id,$event.name)"
          v-model="value"
        )
</template>
<script>
import { mapGetters, mapActions, mapMutations} from 'vuex'
import BaseTaskStateSelect from './BaseTaskStateSelect'
import BaseDateSelect from './BaseDateSelect'

export default {
  components: {
    BaseTaskStateSelect,
    BaseDateSelect
  },
  data () {
    return {
      filterBusinessId: null,
      date: this.getCurrentPeriod(),
      states: [
        {
          name : 'No comenzado',
          color :'#E74C3C'
        },
        {
          name :'En proceso',
          color : '#F1C40F'
        },
        {
          name:'Terminado',
          color:'#2ECC71'
        }
      ],
      filter: '',
      filterOn: ['name', 'rut']
    }
  },
  methods: {
    ...mapActions(['listTasks', 'listBusiness','listBusinessGroups']),
    ...mapActions('BusinessTaskStore',['getMonthlyStatesTask','updateMonthlyStatesTask']),
    ...mapMutations('BusinessTaskStore',['SET_BUSINESSES_MONTHLY_STATES_TASK', 'SET_BUSINESSES_MONTHLY_STATES_TASK_FROM_WEBSOCKET']),

    async updateTaskState (businessId, taskId, state) {
      const data = { businessId, taskId , state}
      const date = this.$moment(this.date, 'DD-MM-YYYY')
      await this.updateMonthlyStatesTask({ data, year: date.year(), month: date.month() + 1 })
      // No es necesario recargar ya que la actualización optimista ya lo hizo
    },
    getCurrentPeriod () {
      const date = this.$moment()
      if (date.date() < 25) {
        return date.subtract(1, 'M').date(1).format('DD-MM-YYYY')
      }
      return date.date(1).format('DD-MM-YYYY')
    },
    getState (name){
      return this.states.find(state => state.name === name).color
    }
  },
  computed: {
    ...mapGetters(['tasks','businesses', 'businessGroups']),
    ...mapGetters('BusinessTaskStore',['businessesMonthlyStatesTask']),
    ...mapGetters('AuthenticationStore',['user']),
    filteredItems () {
      if (this.filterBusinessId) {
        return this.tableItems.filter(i => this.filterBusinessId.includes(i.id))
      }
      return this.tableItems
    },
    tableItems () {
      const items = [...this.businessesMonthlyStatesTask]
      items.map(item => {
        for (const i of item.taskStates) {
          item[`${i.taskId}`] = {
            name: i.state,
            color:this.getState(i.state)
          }
        }
      })
      return items
    },

    tableFields () {
      const fields = [{
        key: 'name',
        label: 'Nombre',
        stickyColumn: true,
        variant: 'light',
        sortable: true
      },
      {
        key: 'rut',
        label: 'Rut',
        sortable: true
      },
      ]
      this.tasks.forEach(task => {
        fields.push({
          sortable: true,
          id: task.id,
          collaboratorId: task.responsableCollaborator.id,
          key: `${task.id}`,
          label: `${task.name}`,
          collaborator:`${task.responsableCollaborator.name}`+` `+`${task.responsableCollaborator.lastName}`.charAt(0)
        })
      })
      return fields
    }
  },
  watch: {
    // controla la suscripción y desuscripción a eventos del home 
    async date (newValue, oldValue) { 
      const newDate = this.$moment(newValue, 'DD-MM-YYYY')
      await this.getMonthlyStatesTask({ year: newDate.year(), month: newDate.month() + 1 })

      const oldDate = this.$moment(oldValue, 'DD-MM-YYYY')
      this.sockets.unsubscribe(`update state ${oldDate.month() + 1}/${oldDate.year()}`)

      this.sockets.subscribe(`update state ${newDate.month() + 1}/${newDate.year()}`, function(data) {
        this.SET_BUSINESSES_MONTHLY_STATES_TASK_FROM_WEBSOCKET({ businessesMonthlyStatesTask: data })
      })
    }
  },
  async created () {
    this.listBusinessGroups()
    const date = this.$moment(this.getCurrentPeriod(), 'DD-MM-YYYY')
    const year = date.year()
    const month = date.month() + 1

    this.sockets.subscribe(`update state ${month}/${year}`, function(data) {
      this.SET_BUSINESSES_MONTHLY_STATES_TASK_FROM_WEBSOCKET({ businessesMonthlyStatesTask: data })
    })
    await this.listTasks()
    await this.getMonthlyStatesTask({ year, month })
  }
}
</script>
<style lang="scss" scoped>
  .badge {
    width: 124px;
    height: 25px;
    font-size: 14px;
    display: block;
    cursor: pointer;
    font-weight: normal;
}
.subtitulo{
  text-align: left;
  font-size: 14px;
}
</style>